import { Skeleton, Button, Space, message, Popover } from 'antd';
import TextArea from 'antd/es/input/TextArea';

import { useStoryFramesQuery } from 'queries/ai-threshold';

const suno_promt_read_story = `No intro. narration female, fast emotional narration. Spoken only.
Style of an ancient legend.
Haunting strings and distant war drums in the background.
Mood: dark, mystical, urgent.`;

const fly_plan2 = `Сделай мне все эти кадры текстом в markdown. Убери нумерацию. Раздели кадры символом ---`;

const fly_plan = `Составь покадровый план истории.
Оформи csv таблицей.
Первый столбец это описание изображения на русском подробно
Второй это presetStyle один из вариантов (На пример CINEMATIC)
Третий столбец это промт для runway на русском с описание движения камеры и объектов в кадре

  { value: 'DYNAMIC', label: 'Dynamic', description: 'Динамичный' },
  { value: 'CINEMATIC', label: 'Cinematic', description: 'Кинематографичный' },
  { value: 'CINEMATIC_CLOSEUP', label: 'Cinematic Close-Up', description: 'Крупный план' },
  { value: 'MOODY', label: 'Moody', description: 'Мрачный' },
  { value: 'HDR', label: 'HDR', description: 'Высокий динамический диапазон' },
  { value: 'LONG_EXPOSURE', label: 'Long Exposure', description: 'Длинная выдержка' },
  { value: 'VIBRANT', label: 'Vibrant', description: 'Яркий' },
  { value: 'FILM', label: 'Film', description: 'Пленочный' },
  { value: 'MONOCHROME', label: 'Monochrome', description: 'Монохромный' },
  { value: 'CREATIVE', label: 'Creative', description: 'Креативный' },
  { value: 'MACRO', label: 'Macro', description: 'Макро' },
  { value: 'BOKEH', label: 'Bokeh', description: 'Размытый задний план с мягкими световыми пятнами. Отлично подчёркивает главный объект.' },
  { value: 'PORTRAIT', label: 'Portrait', description: 'Портретный' },
  { value: 'RETRO', label: 'Retro', description: 'Ретро' },
  { value: 'NEUTRAL', label: 'Neutral', description: 'Нейтральный' },
  { value: 'FOOD', label: 'Food', description: 'Еда' },
  { value: 'FASHION', label: 'Fashion', description: 'Мода' }`;

export const StoryGPT = (props: { qStory: any; storyId: number }) => {
  const story = props.qStory.data?.StoryController_getStoryById || {};
  const qFrames = useStoryFramesQuery(props.storyId);
  if (props.qStory.loading || !story || qFrames.loading) {
    return <Skeleton active />;
  }
  const frames = qFrames.data?.FrameController_getStoryFrames || [];

  const tpl_Seo = `Сделай seo оптимизированное описание и заголовок для видео на основе этого рассказа. И предложи теги через запятую.
  Рассказ: ${story?.initMessage || story?.tts || ''}`;

  let tpl_StoryText = `У меня есть пятисекундные видео в кинемотграфичном стиле, которые я хочу объединить в видео.
  Всего ${frames.length} кадров. Это ${frames.length * 5} секунд видео.

  Придумай сюжет для аудио рассказа, используя эти кадры.
  Рассказ должен быть логичным и последовательным, чтобы его можно было озвучить.
  Используй кадры в любом порядке. Но сюжет должен подходить для кадров.
  Придумай так чтобы рассказ был интересным и захватывающим, чтобы зритель хотел досмотреть видео до конца.
  Целевая аудитория: зрители из США с высоким RPM
  Отформатируй так чтоб итоговый текст я мог скопировать в suno.ai.


  Вот описание кадров:
  ${frames.map((frame, index) => `Кадр ${index + 1}:\nОписание: ${frame.promt}\nДвижение: ${frame.motionPromt}`).join('\n---\n')}
  `;

  const buttons = [
    {
      title: 'Promt for SEO',
      tpl: tpl_Seo,
    },
    {
      title: 'Promt for story creation',
      tpl: tpl_StoryText,
    },
    {
      title: 'Составить список кадров CSV',
      tpl: fly_plan,
    },
    {
      title: 'Составить список кадров Txt',
      tpl: fly_plan2,
    },
    {
      title: 'Promt для SUNO для чтения истории',
      tpl: suno_promt_read_story,
    },
    {
      title: 'Генерация Promt template header',
      tpl: `Сделай промт на общее описание стиля и рисовки который можно будет добавить к каждому кадру из списка для получения более консистентного результата`,
    },
    {
      title: 'Генерация переменных в JSON',
      tpl: `Составь список действующих лиц списком. Просто имена.
Так же в список добавь крупные объекты которые появляются более чем в одном кадре. На пример космический корабль, интерьер сцен.
Затем возми придуманный тобой список и составь из него json объект. Ключ это название объекта без пробелов, а значение промт описывающий внешний вид.
Для описания героев сделай более подробное описание внешности и лица и одежды для персонажа

 ${story?.initMessage || story?.tts || ''}`,
    },
  ];

  return (
    <Space>
      {buttons.map((button, index) => (
        <Popover
          key={index}
          content={
            <div style={{ width: 600 }}>
              <TextArea rows={20} value={button.tpl} />
            </div>
          }
          title={button.title}
          trigger="hover"
        >
          <Button
            type="default"
            size="small"
            onClick={async () => {
              navigator.clipboard.writeText(button.tpl).then(() => message.success('Copied successfully'));
            }}
          >
            {button.title}
          </Button>
        </Popover>
      ))}
    </Space>
  );
};
